var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common" },
    [
      _c("search-form", {
        attrs: {
          noAdvance: true,
          formConfig: _vm.formConfig,
          source: _vm.searchData
        },
        on: { search: _vm.search }
      }),
      _vm._v(" "),
      _c(
        "a-spin",
        {
          staticStyle: { "max-width": "1440px" },
          attrs: { spinning: _vm.loading }
        },
        [
          _c(
            "a-row",
            { attrs: { gutter: [16, 16] } },
            _vm._l(_vm.tableData, function(item) {
              return _c(
                "a-col",
                {
                  key: item.name,
                  attrs: { xs: 24, sm: 12, md: 12, lg: 8, xl: 6 }
                },
                [
                  _c("div", { staticClass: "bank-card" }, [
                    _c("div", { staticClass: "head spaceLeft " }, [
                      _vm.dict.bankListMap[item.bankCd]
                        ? _c("span", {
                            staticClass: "logo",
                            class: _vm.dict.bankListMap[item.bankCd]
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ellipsis",
                          staticStyle: { flex: "1 0 0" },
                          attrs: { title: item.tenantName }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.tenantName) +
                              "\n            "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "body" },
                      [
                        item.approvalStatus == 2 || item.approvalStatus == 4
                          ? [
                              _c("div", { staticClass: "spaceCenter" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "status",
                                    class: _vm.colorMap[item.approvalStatus]
                                  },
                                  [
                                    _c(
                                      "a-popover",
                                      { attrs: { title: "拒绝原因" } },
                                      [
                                        _c("template", { slot: "content" }, [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                color: "#666",
                                                "max-width": "200px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    item.opinion || "暂无原因"
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dictFilter")(
                                                item.approvalStatus,
                                                _vm.aprovalStatus
                                              )
                                            )
                                          )
                                        ])
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          : [
                              _c("div", { staticClass: "spaceCenter" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "status",
                                    class: _vm.colorMap[item.approvalStatus]
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("dictFilter")(
                                            item.approvalStatus,
                                            _vm.aprovalStatus
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ],
                        _vm._v(" "),
                        _c("div", { staticClass: "spaceCenter text" }, [
                          item.approvalStatus == 0 ||
                          item.approvalStatus == 2 ||
                          item.approvalStatus == 4
                            ? _c("span", [_vm._v("点击申请建档，提交信息")])
                            : _c(
                                "span",
                                [
                                  _c("a-icon", {
                                    staticStyle: { "margin-right": "5px" },
                                    attrs: { type: "clock-circle" }
                                  }),
                                  _vm._v(
                                    _vm._s(
                                      _vm
                                        .moment(item.updateTime)
                                        .format("YYYY-MM-DD HH:mm")
                                    )
                                  )
                                ],
                                1
                              )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "spaceCenter" },
                          [
                            item.approvalStatus == 0 ||
                            item.approvalStatus == 2 ||
                            item.approvalStatus == 4
                              ? _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.toAdd(item)
                                      }
                                    }
                                  },
                                  [_vm._v("申请建档")]
                                )
                              : _c(
                                  "a-button",
                                  {
                                    staticClass: "btn-blue-line",
                                    on: {
                                      click: function($event) {
                                        return _vm.toInfo(item)
                                      }
                                    }
                                  },
                                  [_vm._v("查看")]
                                )
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ])
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("a-pagination", {
                staticClass: "bank-page",
                attrs: {
                  size: "small",
                  pageSize: _vm.pagination.pageSize,
                  total: _vm.pagination.total,
                  "show-total": function(total) {
                    return "共 " + _vm.pagination.total + " 条"
                  },
                  "show-quick-jumper": ""
                },
                on: {
                  "update:pageSize": function($event) {
                    return _vm.$set(_vm.pagination, "pageSize", $event)
                  },
                  "update:page-size": function($event) {
                    return _vm.$set(_vm.pagination, "pageSize", $event)
                  },
                  change: _vm.getTableData
                },
                model: {
                  value: _vm.pagination.current,
                  callback: function($$v) {
                    _vm.$set(_vm.pagination, "current", $$v)
                  },
                  expression: "pagination.current"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e24f200", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e24f200","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bank/bank-list.vue
// module id = 4PNd
// module chunks = 1